var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completion"},[_c('span',{class:{'completion--completed': _vm.completed, 'completion--percentage': !_vm.completed },domProps:{"innerHTML":_vm._s(_vm.display)}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d4633de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/vue/completion-percent.vue
// module id = Ws7W
// module chunks = 0